export default __webpack_public_path__ + "static/media/malt.0f9cb3da.webp";